import styled from 'styled-components';

export const StyledCanvasLoader = styled.div`
  background: rgba(36, 41, 47, 0.4);
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 9999999999;
`;
